import { toast } from 'react-toastify'
import { getKeyFromLS } from '../utils/LocalStorageUtil'
export const saveSchoolConcurrently = async (saveMethod, ownerId, schoolId, schoolObject, successMessage) => {

    let result = await saveMethod(ownerId, schoolId, schoolObject)

    if (result && result.status === false) {
        if (result.result === "VersionMissMatchException") {
            let i18n = getKeyFromLS("i18n");
            toast.error("Save Failed with Error - "+ i18n.serverException.VersionMissMatchException);
        } else {
            toast.error("Save Failed with Error - " + result.result);
        }

        return {
            success: false,
            error: result.result
        };

    } else {
        //on success the method returns the updatedschool
        if (successMessage) {
            toast.success(successMessage)
        }

        return {
            success: true,
            updatedSchool: result,
            error: {},
        };

    }
}

export const saveSchoolScheduleConstraintsConcurrently = async (saveMethod, ownerId, schoolId, schoolObject, scheduleIndex, successMessage) => {

    let result = await saveMethod(ownerId, schoolId, schoolObject, scheduleIndex)

    if (result && result.status === false) {
        if (result.result === "VersionMissMatchException") {
            let i18n = getKeyFromLS("i18n");
            toast.error("Save Failed with Error - "+ i18n.serverException.VersionMissMatchException);
        } else {
            toast.error("Save Failed with Error - " + result.result);
        }
        return {
            success: false,
            error: result.result
        };

    } else {
        //on success the method returns the updatedschool
        if (successMessage) {
            toast.success(successMessage)
        }
        
        return {
            success: true,
            updatedSchool: result,
            error: {},
        };

    }
}
//module.exports.saveSchoolConcurrently = saveSchoolConcurrently;

